import React from 'react';

const Vue_errorCaptured = () => {
  return (
    <div>
      <h1>Vue_errorCaptured Component</h1>
      <p>This is the Vue_errorCaptured tutorial page.</p>
    </div>
  );
}

export default Vue_errorCaptured;
